// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const ColorWheel = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="4px"
      strokeLinecap="round"
    >
      <circle cx="24" cy="12.2" r="10.1" />
      <line x1="9" y1="32.6" x2="39" y2="32.6" />
      <line x1="9" y1="39.2" x2="39" y2="39.2" />
      <line x1="9" y1="45.9" x2="39" y2="45.9" />
    </svg>
  );
};
